import { renderAuthorshipValueActorTemplate } from '@next-adapter/templates/renderers/generators/columns/column-defs/generate-authorship-value.js'
export function generateAuthorshipValue(userAccessor: 'createdByUser' | 'updatedByUser'): string {
  return renderAuthorshipValueActorTemplate({ userAccessor: userAccessor })
}
